// import zhLocale from 'element-ui/lib/locale/lang/zh-TW'
export default {
    page: {
        other: {
            login: {
                title: "通路管理系統",
                forgetPwd: "找回密碼？",
                alert: {
                    failed: "用戶名或密碼錯誤",
                    count: "第{errorCount}次",
                    note: "5次輸入錯誤用戶將鎖定",
                    lockTip: "此帳號已凍結",
                    str: ["請聯絡", "或"],
                    link: ["客服人員", "申請解鎖"],
                    pMode: "系統維護中",
                },
            },
            forgetPwd: {
                title: "忘記密碼",
            },
            restoreAccount: {
                title: "申請解鎖",
            },
        },
    },
    component: {
        header: {
            title: "通路管理系統",
        },
        dropdown: {
            areaCode: "請選擇區碼",
        },
        form: {
            input: {
                placeholder: {
                    username: "用戶名",
                    mobile: "請輸入移動電話",
                    graphicValidation: "請輸入圖形驗證",
                },
            },
        },
        btn: {
            login: "登錄",
            confirm: '確認',
        },
        label: {
            rememberMe: "記住我"
        },
        dialog: {
            title: "提示"
        },
    },
    column: {
        password: "密碼",
        input_username: "輸入帳號",
        mobile: "移動電話",
        graphicValidation: "圖形驗證",
    },
    // ...zhLocale
};
